/**
 * ==========================================================================
 *  verwandtschaft.js — zentrale Liste der Verwandtschafts-/Beziehungs-Optionen
 * ==========================================================================
 *  Wird sowohl im Booking-Widget (BookingWidget.jsx) als auch im
 *  Berater-Dashboard-Stammdaten-Modal verwendet, damit die Auswahlmoeglich-
 *  keiten ueberall identisch sind.
 *
 *  Gruppierung in drei Bloecke (engste Familie / Familie / Nicht-Familie),
 *  damit die Liste im Dropdown via <optgroup> uebersichtlich bleibt.
 *
 *  Wenn neue Beziehungstypen ergaenzt werden, MUSS personalisierung.js
 *  parallel um Eintraege in VERWANDT_AUS_PATIENT_SICHT und
 *  PATIENT_AUS_PFLEGEPERSON_SICHT erweitert werden — sonst nutzt das
 *  Sicht-Bausteine-Feature im Protokoll automatisch die Sonstiges-Fallbacks.
 * ==========================================================================
 */

export const VERWANDTSCHAFT_GRUPPEN = [
  {
    label: 'Engste Familie',
    optionen: [
      'Ehefrau',
      'Ehemann',
      'Lebensgefährtin',
      'Lebensgefährte',
      'Tochter',
      'Sohn',
    ],
  },
  {
    label: 'Familie (weiter)',
    optionen: [
      'Mutter',
      'Vater',
      'Schwester',
      'Bruder',
      'Schwiegertochter',
      'Schwiegersohn',
      'Enkelin',
      'Enkel',
    ],
  },
  {
    label: 'Nicht-Familie',
    optionen: [
      'Nachbarin',
      'Nachbar',
      'Freundin',
      'Freund',
      'Sonstiges',
    ],
  },
];

// Flache Liste, falls jemand das mal ohne Gruppierung braucht
export const VERWANDTSCHAFT_FLACH = VERWANDTSCHAFT_GRUPPEN.flatMap(g => g.optionen);
